import React from 'react';
import { Box } from '@mui/material';
import Navbar from '../Navbar';
import Sidebar from '../SideBar/Sidebar';

const CONTENT_STYLES = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  marginLeft: '280px',
  marginTop: '80px',
};

/**
 * Standard page layout with Navbar + Sidebar + content area.
 * Use for all authenticated pages.
 */
const PageLayout = ({ children, sx = {}, ...rest }) => (
  <Box sx={{ display: 'flex', minHeight: '100vh' }} {...rest}>
    <Navbar />
    <Sidebar />
    <Box sx={{ ...CONTENT_STYLES, ...sx }}>{children}</Box>
  </Box>
);

export default PageLayout;
